import React from 'react';

import { formatDate, waFormat } from 'utilities/common';
import Datagrid from 'ui/components/data/grid';
import { isValidDate, currencyFormat } from 'utilities/common';

const manifestType = {
  last_mile: 'Last Mile',
  pickup: 'First Mile',
  console: 'Mid Mile',
  forwarder: 'Forward',
  return: 'Return',
};

export const SectionInfo = ({ manifest, loading }) => {
  const LandFreight = ({ data }) => {
    if (!data) return null;

    const getDriver = (data) => {
      return data?.driver
        ? `${data?.driver?.name} (${waFormat(data?.driver?.phone)})`
        : '-';
    };

    return (
      <>
        <Datagrid
          loading={loading}
          title="Driver/Kurir"
          value={getDriver(data)}
        />
        <Datagrid
          loading={loading}
          title="Kendaraan"
          value={data?.vehicle ? `${data?.vehicle?.code}` :`${data?.vehicle_number} - ${data?.vehicle_type?.name}`}
        />
      </>
    );
  };

  const SeaFreight = ({ data }) => {
    if (!data) return null;

    return (
      <>
        <Datagrid
          loading={loading}
          title="Kode BL"
          value={data?.bl_code || '-'}
        />
        <Datagrid
          loading={loading}
          title="No. Container"
          value={data?.no_container || '-'}
        />
        <Datagrid
          loading={loading}
          title="No. Vessel"
          value={data?.no_vessel || '-'}
        />
      </>
    );
  };

  const AirFreight = ({ data }) => {
    if (!data) return null;

    return (
      <>
        <Datagrid
          loading={loading}
          title="Kode SMU"
          value={data?.code_smu || '-'}
        />
        <Datagrid
          loading={loading}
          title="No. Manifest"
          value={data?.no_manifest || '-'}
        />
      </>
    );
  };

  return (
    <div className="p-0 p-md-3 pe-md-0 mb-3 mb-md-0">
      <div className="card rounded-2 bg-white">
        <div className="card-header-gray p-3 border-bottom">
          <h3 className="card-title dx-card-title m-0 p-0">
            Manifest Information
          </h3>
        </div>
        <div className="card-body p-3 pt-3">
          <div className="row">
            <div className="col-6">
              <div className="datagrid">
                <Datagrid
                  loading={loading}
                  title="Kode Manifest"
                  value={manifest?.code}
                />
                {manifest?.moda_type && (
                  <Datagrid
                    loading={loading}
                    title="Moda"
                    value={manifest?.moda_type?.replace('_', ' ')}
                  />
                )}
                <Datagrid
                  loading={loading}
                  title="Vendor"
                  value={manifest?.vendor?.name || '-'}
                />
                <LandFreight data={manifest?.moda?.land_freight} />
                <SeaFreight data={manifest?.moda?.sea_freight} />
                <AirFreight data={manifest?.moda?.air_freight} />
              </div>
            </div>
            <div className="col-6">
              <div className="datagrid">
                <Datagrid
                  loading={loading}
                  title="Tipe Dispatch"
                  value={manifestType[manifest?.type]}
                />
                <Datagrid
                  loading={loading}
                  title="Rencana Pengiriman"
                  value={formatDate(manifest?.schedule_at, 'DD/MM/YYYY')}
                />
                <Datagrid
                  loading={loading}
                  title="Dispatcher"
                  value={manifest?.created_by}
                />
                <Datagrid
                  loading={loading}
                  title="Tanggal Dibuat"
                  value={formatDate(manifest?.created_at)}
                />
                {isValidDate(manifest?.completed_at) && (
                  <Datagrid
                    loading={loading}
                    title="Tanggal Selesai"
                    value={formatDate(manifest?.completed_at)}
                  />
                )}

                <Datagrid
                  loading={loading}
                  title="Harga Pengiriman"
                  value={currencyFormat(manifest?.total_cost, 'IDR')}
                />

                {(manifest?.cod && manifest?.cod?.value > 0) && (
                  <Datagrid
                    loading={loading}
                    title="COD"
                    value={`${currencyFormat(manifest?.cod?.receive)} / ${currencyFormat(manifest?.cod?.value)}`}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
